module.exports = __webpack_public_path__ + "img/memoir_rings@2x.1556873.webp";